import brandLogo from "./assets/infomaniak.png";

export const CAREERS_BRAND_NAME = "Infomaniak Careers";
export const CAREERS_LOGO = brandLogo;
export const CAREERS_LOGO_ALT = "Infomaniak";
/** @deprecated Use CAREERS_LOGO — kept so legacy `sapLogo` references still resolve */
export const sapLogo = brandLogo;
